import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _CustomProcessType, _SignAndApprovalPanel } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { Singleton } from "../../../../core/services/Singleton";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { InputDate } from "../../../theme/Input/InputDate";
import { EditorSignAndApprovalPanel } from "../../../contabilidad/SignAndApprovalPanel/EditorSignAndApprovalPanel";




export const CustomProcessType = () => {

    const CustomProcessType = useDataBean(_CustomProcessType);
    const single = Singleton.getInstance();
    const [processType, setProcessType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null);
    const [simularfirmas, setSimularfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [verfirmas, setVerfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        // getLista();
    }, [])

    const getLista = () => {

        CustomProcessType.instance.getCustomProcessTypeCatalogByProcessType(processType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }


    const create = () => {
        CustomProcessType.setBean({
            ProcessType: CustomProcessType.bean.ProcessType,
            IDEmployee: single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        CustomProcessType.deleteItemVoid(CustomProcessType.bean.IDCustomProcessType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        CustomProcessType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCustomProcessType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Flujo de Firma', property: 'SignAndApprovalPanelName', visible: true },
        { title: 'Descripción', property: 'Observations', visible: true },
        { title: 'Propiedades Json', property: 'JsonProperties', visible: true },
        { title: 'Clase Java', property: 'ClassForName', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${CustomProcessType.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Catálogo de Subprocesos Quick">
            <div className="row">
                <div className="col-md-6">
                    <SelectTypeProcees label="Tipo de Proceso" idSelector={processType} onChange={(e) => setProcessType(e)} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={CustomProcessType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={CustomProcessType.bean.Name} onChange={CustomProcessType.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={CustomProcessType.bean.Code} onChange={CustomProcessType.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={CustomProcessType.bean.ProcessType} onChange={(e: any) => { CustomProcessType.setBean({ ...CustomProcessType.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <EditorSignAndApprovalPanel label='Flujo de Firma' idSelector={CustomProcessType.bean.IDSignAndApprovalPanel} onChange={(e: any) => { CustomProcessType.setBean({ ...CustomProcessType.bean, "IDSignAndApprovalPanel": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase Java</label>
                                <input type="text" name="ClassForName" className="form-control" value={CustomProcessType.bean.ClassForName} onChange={CustomProcessType.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Desde" name="Since" value={CustomProcessType.bean.Since} setDate={(e) => { CustomProcessType.setBean({ ...CustomProcessType.bean, "Since": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Propiedades Json</label>
                                <textarea name="JsonCode" className="form-control" value={CustomProcessType.bean.JsonCode} onChange={CustomProcessType.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Observations" className="form-control" value={CustomProcessType.bean.Observations} onChange={CustomProcessType.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {CustomProcessType.bean.Name}</strong>
                    </ModalConfirm>

                </div>

            </div>
        </BasicPage>
    )
}